import { SearchRequest } from '../common/SearchRequest';

export class PersonSearchRequest extends SearchRequest {

	public genderIds: number[];
	public isEnabled?: boolean;
	public companyIds: string[];

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.companyIds) {
			this.companyIds = Array.isArray(init.companyIds)
				? init.companyIds
				: init.companyIds.split(',');
		}
		if (init.genderIds) {
			if (Array.isArray(init.genderIds)) {
				this.genderIds = init.genderIds;
			} else {
				const genders = init.genderIds.split(',');
				this.genderIds = genders.map((x) => parseInt(x, null));
			}
		}
		if (init.isEnabled != null) { this.isEnabled = (init.isEnabled.toString() === 'true'); }
	}

	public collapse(): any {
		const response: { [k: string]: any } = {};
		if (this.pageIndex) { response.pageIndex = this.pageIndex; }
		if (this.pageSize) { response.pageSize = this.pageSize; }
		if (this.criteria) { response.criteria = this.criteria; }
		if (this.sortBy) { response.sortBy = this.sortBy; }
		if (this.sortDirection) { response.sortDirection = this.sortDirection; }
		if (this.companyIds && this.companyIds.length) { response.companyIds = this.companyIds.join(','); }
		if (this.isEnabled != null) { response.isEnabled = this.isEnabled; }
		if (this.genderIds && this.genderIds.length) { response.genderIds = this.genderIds.join(','); }
		return response;
	}

	public clear() {
		this.pageIndex = 0;
		this.pageSize = 20;
		this.criteria = '';
		this.sortDirection = null;
		this.sortBy = null;
		this.isEnabled = null;
		this.companyIds = [];
		this.genderIds = [];
	}
}
